import useSWR from "swr";
import {
  CurrentPriceResponse,
  fetcher,
  isinUrl,
  REFRESH_TIME_LONG,
} from "./data";
import { numberWithCommas } from "./formatters";
import React, { useContext } from "react";
import Settings from "../settings";
import { format } from "date-fns/esm";

const SharePriceHeader = () => {
  const { getSetting } = useContext(Settings);

  const { data } = useSWR<CurrentPriceResponse>(
    isinUrl("price", getSetting("sharePriceGlobal.isin")),
    fetcher,
    { refreshInterval: REFRESH_TIME_LONG }
  );

  if (!data) return null;

  const fetched = data?.current.isoTimestamp
    ? new Date(data.current.isoTimestamp)
    : null;


  return (
    <div className={`share-price-header ${data.change.direction}`}>
      <span className="title">{getSetting("sharePriceHeader.label")}</span>
      <span className="current-price">
        {/*@ts-ignore*/}
        {numberWithCommas(data.current.close, getSetting("sharePriceDetailed.decimalPlaces") || 2)}
      </span>
      {getSetting("sharePriceHeader.sections.showCurrency") && (
        <span className="currency">
          {getSetting("sharePriceHeader.currency")}
        </span>
      )}
      {getSetting("sharePriceHeader.sections.showDirectionArrow") && (
        <svg height="40" width="50" viewBox="0 0 50 40">
          <polygon
            points="25,1 1,39 49,39"
            className="triangle"
            style={{ stroke: "none" }}
          />
        </svg>
      )}
      {getSetting("sharePriceHeader.sections.showDirectionArrow") && (
        <span>{numberWithCommas(data.change.amount, getSetting("sharePriceDetailed.decimalPlaces") || 2)}p</span>
      )}
      {getSetting("sharePriceHeader.sections.showChangePercent") && (
        <span>{data.change.pct}%</span>
      )}
      {getSetting("sharePriceHeader.sections.showTimestamp") && fetched && (
        <span>
          {format(fetched, getSetting("sharePriceHeader.timestampFormat"))}
        </span>
      )}
    </div>
  );
};
export default SharePriceHeader;
